import { render, staticRenderFns } from "./countries-table.vue?vue&type=template&id=09201e00&scoped=true&"
import script from "./countries-table.vue?vue&type=script&lang=js&"
export * from "./countries-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09201e00",
  null
  
)

export default component.exports